<template>
    <div>
        <div class="tabs">
            <ul class="tabs__navigation d-flex">
                <li class="tabs__navigation-item" v-for="tab in tabs"
                    :class="{ 'tabs__navigation-item--active': tab.isActive }"
                    :style="'width: ' + 100 / tabs.length + '%'">
                    <button class="tabs__navigation-btn d-flex" @click.prevent="selectTab(tab)">{{ tab.name }}</button>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {

    name: "Tabs",
    data() {
        return {
            tabs: [],
        };
    },

    created() {
        this.tabs = this.$children;
    },
/*    mounted(){
        let activeElement = this.tabs.find( e => e.isActive );
        activeElement = activeElement.name
        this.$emit('markAsRead', activeElement)
    },*/
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.name === selectedTab.name);

                // if( tab.isActive ){
                //     this.$emit('markAsRead', selectedTab.name)
                // }

            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/helpers';

.tabs {
    &__navigation {
        padding: 0;
        margin: 0;
        list-style: none;

        &-item {
            position: relative;
            flex-grow: 1;

            & + .tabs__navigation-item {
                border-left: 1px solid #ECECEC;
            }

            &::after {
                position: absolute;
                display: block;
                content: '';

                bottom: 0;
                left: 0;
                right: 0;

                height: 3px;
                opacity: 0;
                background: $primaryBlue;

                transition: opacity .2s ease;
            }

            &--active {
                &::after {
                    opacity: 1;
                }
            }
        }

        &-btn {
            width: 100%;
            padding: 26px 14px;
            justify-content: center;
            align-items: center;
            background: transparent;
            border: none;
            box-shadow: none;


        }
    }


}


@media screen and (max-width: 1200px) {
    .tabs__navigation-btn {
        font-size: 12px;
    }
}


</style>
